import { Div } from '../../../../base/components/native/div'
import { FAQItem } from './faq-item'

export const FAQItems = () => {

    const base = Div()

    const raw = [
        {
            Q: 'How does the design generation process work?',
            A: 'The design generation process involves using AI algorithms to create unique designs based on user input and preferences. Users can select from a variety of templates, customize colors and layouts, and preview their designs before ordering.',
        }, {
            Q: 'Can I upload my own images or designs to be printed?',
            A: 'Yes, the website allows users to upload their own images or designs to be printed.'
        }, {
            Q: 'What file types are accepted for uploading ?',
            A: 'The website accepts a variety of file types, including JPEG, PNG, and PDF.'
        }, {
            Q: 'What materials can be used for printing ?',
            A: 'The website offers printing on a variety of materials, including paper, canvas, metal, and wood.',
        }, {
            Q: 'Are there any limitations on the size of the designs that can be printed?',
            A: 'Yes, there are limitations on the size of designs that can be printed, depending on the material and print method used.'
        }, {
            Q: 'How long does the printing process take?',
            A: 'The printing process varies depending on the size and complexity of the design, but most orders are processed within a few days.'
        }, {
            Q: 'What is the cost of using the service?',
            A: 'The cost of using the service varies depending on the size, material, and print method selected.Prices can be found on the website.'
        }, {
            Q: 'Are there any bulk or wholesale discounts available?',
            A: 'Yes, there are bulk and wholesale discounts available for large orders.'
        }, {
            Q: 'What is the process for returning or exchanging a printed item?',
            A: 'If you are not satisfied with your printed item, please contact customer support for assistance with returning or exchanging the item.'
        }, {
            Q: 'How can I ensure the quality of the printed product?',
            A: 'Our website uses high- quality printing equipment and materials to ensure that all products are of the highest quality.'
        }
    ]
    raw.forEach(item => {
        const faq = FAQItem(item.Q, item.A)
        base.append(faq)
    })

    base.cssClass({
        textAlign: 'left',
        maxWidth: '980px',
        width: 'calc(100% - 40px)',
    })

    return base
}